/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Afterpay visibility toggle based on variant price
  document.querySelectorAll('[data-section-type="product-template"]').forEach(function(section) {
    if (section.dataset.afterpayMinEnabled !== 'true') return;
    
    var minPrice = parseInt(section.dataset.afterpayMinPrice, 10) || 3000;
    
    section.addEventListener('theme:variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        section.classList.toggle('afterpay-hidden', e.detail.variant.price < minPrice);
      }
    });
  });


 // ─── Assortion Discount Badge Override ─────────────────────────────────────
  // Assortion's cart drawer hardcodes its discount badge as "X% off (a% + b%)"
  // with no admin setting to change it. This override rewrites the badge to
  // "X% + Y%" (multi-buy + subscription) or "X% off" (multi-buy only).
  //
  // Targets: .ast-cart__item .ast-tag__text
  // Data source: /cart.js
  // ───────────────────────────────────────────────────────────────────────────
  console.log('[AST Badge] Script loaded');

  var astBadgeTimer = null;
  var astLastBadgeText = null;

  function reformatAssortionBadges(cartData) {
    var items = cartData.items;

    var itemByHandle = {};
    items.forEach(function(item) {
      itemByHandle[item.handle] = item;
    });

    document.querySelectorAll('.ast-cart__item').forEach(function(cartItemEl) {
      var badge = cartItemEl.querySelector('.ast-tag__text');
      if (!badge) return;

      var link = cartItemEl.querySelector('a[href*="/products/"]');
      if (!link) return;

      var handle = link.getAttribute('href')
        .replace(/^\/products\//, '')
        .split('?')[0]
        .split('#')[0];

      var item = itemByHandle[handle];
      if (!item) {
        console.log('[AST Badge] No cart item for handle:', handle, '| handles available:', Object.keys(itemByHandle));
        return;
      }

      var subscriptionPercent = 0;
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        var adjustments = item.selling_plan_allocation.selling_plan.price_adjustments || [];
        for (var i = 0; i < adjustments.length; i++) {
          if (adjustments[i].value_type === 'percentage') {
            subscriptionPercent = Math.round(adjustments[i].value);
            break;
          }
        }
      }

      var allocations = item.line_level_discount_allocations || [];
      var multiBuyAmount = allocations.reduce(function(sum, alloc) {
        return sum + (alloc.amount || 0);
      }, 0);
      var originalLinePrice = item.original_line_price || 0;
      var multiBuyPercent = 0;
      if (multiBuyAmount > 0 && originalLinePrice > 0) {
        multiBuyPercent = Math.round(multiBuyAmount * 100 / originalLinePrice);
      }

      console.log('[AST Badge] handle:', handle, '| multiBuyPercent:', multiBuyPercent, '| subscriptionPercent:', subscriptionPercent, '| allocations:', allocations, '| selling_plan_allocation:', item.selling_plan_allocation);

      if (multiBuyPercent > 0 && subscriptionPercent > 0) {
        badge.textContent = multiBuyPercent + '% + ' + subscriptionPercent + '%';
      } else if (multiBuyPercent > 0) {
        badge.textContent = multiBuyPercent + '% off';
      }

      console.log('[AST Badge] Final badge text:', badge.textContent);
    });
  }

  function fetchAndReformatBadges() {
    var badges = document.querySelectorAll('.ast-cart__item .ast-tag__text');
    if (!badges.length) return; // No badges visible, skip fetch

    console.log('[AST Badge] Fetching /cart.js for', badges.length, 'badge(s)...');
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(reformatAssortionBadges)
      .catch(function(e) { console.error('[AST Badge] Fetch error:', e); });
  }

  function debouncedBadgeReformat() {
    clearTimeout(astBadgeTimer);
    astBadgeTimer = setTimeout(fetchAndReformatBadges, 300);
  }

  // ── MutationObserver: watch for any ast- prefixed elements added to DOM ──
  var astObserver = new MutationObserver(function(mutations) {
    var hasAstNodes = mutations.some(function(m) {
      return Array.from(m.addedNodes).some(function(n) {
        if (n.nodeType !== 1) return false;
        var cls = (typeof n.className === 'string') ? n.className : '';
        if (cls.indexOf('ast-') !== -1) return true;
        if (n.querySelector && n.querySelector('[class*="ast-cart"]')) return true;
        return false;
      });
    });
    if (hasAstNodes) {
      console.log('[AST Badge] ast- node detected in DOM');
      debouncedBadgeReformat();
    }
  });

  astObserver.observe(document.body, { childList: true, subtree: true });

  // ── Click listener: catch cart open/close and quantity changes ───────────
  // Assortion renders lazily — firing after any click covers cart toggle,
  // quantity buttons, and variant changes.
  document.addEventListener('click', function() {
    setTimeout(function() {
      if (document.querySelector('.ast-cart__item .ast-tag__text')) {
        debouncedBadgeReformat();
      }
    }, 500);
  });
  // ─── End Assortion Discount Badge Override ──────────────────────────────────


//--------Start Flavour popup Mobile-----------
  // flavour-popup-mobile.js
// Mobile only (≤768px): intercepts .siblings__swatch--image clicks and shows
// a flavour popup (image + name + VIEW PRODUCT CTA) instead of navigating.
// Flavour name sourced from data-tooltip; image from swatch img scaled to 600px.
// No API calls. Self-contained — injects its own styles on first open.

(function () {
  if (!document.querySelector('.siblings__swatch--image')) return;

  var BREAKPOINT = 768;

  var overlay, imgEl, nameEl, viewBtn, prevBtn, nextBtn;
  var swatches = [];
  var currentIdx = 0;

  // ─── Styles ─────────────────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('fp-styles')) return;
    var s = document.createElement('style');
    s.id = 'fp-styles';
    s.textContent = [
      '#fp-overlay{display:none;position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.65);justify-content:center;align-items:center;padding:24px}',
      '#fp-overlay.fp-open{display:flex}',
      '#fp-card{position:relative;background:#f5efe6;border-radius:20px;width:100%;max-width:320px;padding:20px 28px 24px;display:flex;flex-direction:column;gap:16px}',
      '#fp-close{position:absolute;top:-14px;right:-14px;width:32px;height:32px;border-radius:50%;background:#fff;border:none;font-size:22px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.2);padding:0;color:#1a1a1a}',
      '#fp-img-wrap{position:relative;background:#fff;border-radius:14px;aspect-ratio:1 / 1}',
      '#fp-img-clip{position:absolute;inset:0;overflow:hidden;border-radius:14px}',
      '#fp-img{width:100%;height:100%;object-fit:contain;display:block;transition:transform 0.28s ease,opacity 0.28s ease}',
      '.fp-exit-left{transform:translateX(-110%) !important;opacity:0 !important}',
      '.fp-exit-right{transform:translateX(110%) !important;opacity:0 !important}',
      '.fp-enter-left{transform:translateX(-110%) !important;opacity:0 !important;transition:none !important}',
      '.fp-enter-right{transform:translateX(110%) !important;opacity:0 !important;transition:none !important}',
      '#fp-prev,#fp-next{position:absolute;top:50%;transform:translateY(-50%);width:36px;height:36px;border-radius:50%;background:#fff;border:none;font-size:26px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,.15);padding:0;color:#1a1a1a;z-index:1}',
      '#fp-prev{left:-18px}',
      '#fp-next{right:-18px}',
      '#fp-name{font-weight:700;font-size:17px;text-align:center;margin:0;color:#1a1a1a;line-height:1.3}',
      '#fp-view{display:block;background:#1a1a1a;color:#fff !important;text-align:center;padding:15px 20px;border-radius:999px;font-size:12px;font-weight:700;letter-spacing:.1em;text-decoration:none !important;text-transform:uppercase}'
    ].join('');
    document.head.appendChild(s);
  }

  // ─── Build DOM ───────────────────────────────────────────────────────────────
  function buildPopup() {
    injectStyles();

    overlay = document.createElement('div');
    overlay.id = 'fp-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    var card = document.createElement('div');
    card.id = 'fp-card';

    var closeBtn = document.createElement('button');
    closeBtn.id = 'fp-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';

    var imgWrap = document.createElement('div');
    imgWrap.id = 'fp-img-wrap';

    var imgClip = document.createElement('div');
    imgClip.id = 'fp-img-clip';

    imgEl = document.createElement('img');
    imgEl.id = 'fp-img';
    imgEl.alt = '';

    prevBtn = document.createElement('button');
    prevBtn.id = 'fp-prev';
    prevBtn.setAttribute('aria-label', 'Previous flavour');
    prevBtn.innerHTML = '&#8249;';

    nextBtn = document.createElement('button');
    nextBtn.id = 'fp-next';
    nextBtn.setAttribute('aria-label', 'Next flavour');
    nextBtn.innerHTML = '&#8250;';

    nameEl = document.createElement('p');
    nameEl.id = 'fp-name';

    viewBtn = document.createElement('a');
    viewBtn.id = 'fp-view';
    viewBtn.textContent = 'VIEW PRODUCT';

    imgClip.appendChild(imgEl);
    imgWrap.appendChild(imgClip);
    imgWrap.appendChild(prevBtn);
    imgWrap.appendChild(nextBtn);
    card.appendChild(closeBtn);
    card.appendChild(imgWrap);
    card.appendChild(nameEl);
    card.appendChild(viewBtn);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });
    prevBtn.addEventListener('click', function () { navigate(-1); });
    nextBtn.addEventListener('click', function () { navigate(1); });
  }

  // ─── Open / Close ────────────────────────────────────────────────────────────
  function openPopup(all, idx) {
    if (!overlay) buildPopup();
    swatches = all;
    currentIdx = idx;
    renderSlide(currentIdx);
    overlay.classList.add('fp-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    overlay.classList.remove('fp-open');
    document.body.style.overflow = '';
  }

  var sliding = false;

  function navigate(dir) {
    if (sliding) return;
    sliding = true;
    var newIdx = (currentIdx + dir + swatches.length) % swatches.length;
    var exitClass = dir > 0 ? 'fp-exit-left' : 'fp-exit-right';
    var enterClass = dir > 0 ? 'fp-enter-right' : 'fp-enter-left';

    imgEl.classList.add(exitClass);

    setTimeout(function () {
      currentIdx = newIdx;
      var swatch = swatches[newIdx];
      var newSrc = getImageUrl(swatch);
      var newName = getFlavorName(swatch);
      var newHref = swatch.getAttribute('href') || '#';

      // Park off-screen with no transition while image loads
      imgEl.classList.remove(exitClass);
      imgEl.classList.add(enterClass);

      function onReady() {
        imgEl.onload = imgEl.onerror = null;
        nameEl.textContent = newName;
        viewBtn.href = newHref;
        imgEl.offsetHeight; // force reflow so transition fires
        imgEl.classList.remove(enterClass);
        sliding = false;
      }

      imgEl.onload = onReady;
      imgEl.onerror = onReady;
      imgEl.src = newSrc;
    }, 280);
  }

  // ─── Helpers ─────────────────────────────────────────────────────────────────
  function getImageUrl(swatch) {
    var img = swatch.querySelector('img');
    if (!img) return '';

    // src attr holds the 2048px URL before browser applies lazy-load srcset swap
    var src = img.getAttribute('src') || '';
    if (src && src.indexOf('blank') === -1 && src.indexOf('loading') === -1) {
      return src
        .replace(/width=\d+/g, 'width=600')
        .replace(/height=\d+/g, 'height=600')
        .replace(/crop=\w+&?/g, '');
    }

    // Lazy placeholder active — fall back to srcset URL scaled up
    var srcset = img.getAttribute('srcset') || '';
    var firstUrl = (srcset.split(',')[0] || '').trim().split(/\s+/)[0] || '';
    return firstUrl ? firstUrl.replace(/width=\d+/, 'width=600') : '';
  }

  function getFlavorName(swatch) {
    var btn = swatch.querySelector('[data-tooltip]');
    if (btn) return btn.getAttribute('data-tooltip') || '';
    var hidden = swatch.querySelector('.visually-hidden');
    return hidden ? hidden.textContent.trim() : '';
  }

  function renderSlide(idx) {
    var swatch = swatches[idx];
    imgEl.src = getImageUrl(swatch);
    nameEl.textContent = getFlavorName(swatch);
    viewBtn.href = swatch.getAttribute('href') || '#';

    var multiple = swatches.length > 1;
    prevBtn.style.display = multiple ? 'flex' : 'none';
    nextBtn.style.display = multiple ? 'flex' : 'none';
  }

  // ─── Click interception ───────────────────────────────────────────────────────
  // Capture phase ensures preventDefault fires before the <a> navigates.
  document.addEventListener('click', function (e) {
    if (window.innerWidth > BREAKPOINT) return;

    var swatch = e.target.closest && e.target.closest('.siblings__swatch--image');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    var fieldset = swatch.closest('.siblings');
    if (!fieldset) return;

    var all = Array.from(fieldset.querySelectorAll('.siblings__swatch--image'));
    openPopup(all, all.indexOf(swatch));
  }, true);

})();
 //--------End Flavour popup Mobile-----------

  // ─── BOGOS gift slider: fill Assortion's slot when it mounts late ───────────
  // BOGOS renders its in-cart gift slider into every .bogos-gift-slider-view that
  // exists at render time. The visible one sits in Assortion's cart drawer (Embed
  // block) and Preact rebuilds it after each cart change, so it often appears
  // *after* BOGOS has already rendered into the hidden placeholder in
  // layout/theme.liquid, and stays empty. Move the rendered nodes across;
  // BOGOS's click listeners travel with the nodes (verified: moved "Add" button
  // still adds the gift).
  // ponytail: DOM move instead of asking BOGOS to redraw. BOGOS exposes no
  // re-render call, and a no-op /cart/update.js does not make it redraw.
  // ───────────────────────────────────────────────────────────────────────────
  var bogosSlotTimer = null;

  function fillBogosSlot() {
    var slot = document.querySelector('.ast-cart__embed .bogos-gift-slider-view');
    var hidden = document.querySelector('body > .bogos-gift-slider-view');
    if (!slot || !hidden || slot.firstChild) return;
    if (!hidden.querySelector('.bogos-gifts-slider-container')) return;

    while (hidden.firstChild) slot.appendChild(hidden.firstChild);
    slot.classList.add('freegifts-main-container');
    // re-init the carousel, it was measured while hidden
    document.dispatchEvent(new CustomEvent('bogos:glider'));
  }

  new MutationObserver(function () {
    if (bogosSlotTimer) return;
    bogosSlotTimer = setTimeout(function () {
      bogosSlotTimer = null;
      fillBogosSlot();
    }, 150);
  }).observe(document.body, { childList: true, subtree: true });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
